import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=ae9fa3c4&scoped=true&"
import script from "./ProfilePopup.vue?vue&type=script&lang=js&"
export * from "./ProfilePopup.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePopup.vue?vue&type=style&index=0&id=ae9fa3c4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9fa3c4",
  null
  
)

export default component.exports